import { nbspJsString } from '@/packages/shared-ui/symbols/symbols';

export function splitStringToMaxCharsInRow(
  str: string,
  maxCharsInRow: number,
  wordsJoiner = nbspJsString,
): Array<string> {
  const publisherNameArr = str.split(' ');

  const publisherNameWithNBSP = [publisherNameArr[0]];

  for (let currentIndex = 1; currentIndex < publisherNameArr.length; currentIndex += 1) {
    const currentValue = publisherNameArr[currentIndex];
    const last = publisherNameWithNBSP.length - 1;

    if (publisherNameWithNBSP[last].length + currentValue.length <= maxCharsInRow) {
      publisherNameWithNBSP[last] += `${wordsJoiner}${currentValue}`;
    } else {
      publisherNameWithNBSP.push(currentValue);
    }
  }

  return publisherNameWithNBSP;
}
